import { render } from "./DefaultLayoutRenderer.vue?vue&type=template&id=b3375c2a&ts=true"
import script from "./DefaultLayoutRenderer.vue?vue&type=script&lang=ts"
export * from "./DefaultLayoutRenderer.vue?vue&type=script&lang=ts"

import "./DefaultLayoutRenderer.vue?vue&type=style&index=0&id=b3375c2a&lang=scss"
import "./DefaultLayoutRenderer.vue?vue&type=style&index=1&id=b3375c2a&lang=scss"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__